import { usePlanIsChangeOnlyOption as useIsChangeOnlyOption } from "@/components/features/items/edit/plan/_shared/ui/components/plan-attributes/is-only-change-option/hooks";

import { useProductPlanFormModelContext } from "../../../../context";

export const usePlanIsChangeOnlyOption = () => {
	const { viewModel, onSetViewModel } = useProductPlanFormModelContext();
	const { isChangeOnlyOption } = viewModel;

	return useIsChangeOnlyOption({
		isChangeOnlyOption,
		onSetViewModel,
	});
};
